export default "/images/file.svg?57e885a5946e533ebd772668f05b8844";